import Transform from '@ember-data/serializer/transform';

class Currency extends Transform {
  deserialize(serialized: number | null): number | null {
    return serialized ? serialized / 100 : null;
  }

  serialize(deserialized: number | null): number | null {
    return deserialized ? deserialized * 100 : null;
  }
}

declare module 'ember-data/types/registries/transform' {
  export default interface TransformRegistry {
    currency: Currency;
  }
}

export default Currency;
